import { ReactNode } from 'react';
import styled from 'styled-components';

interface Props {
  title?: string;
  description: ReactNode;
  onCancel: () => void;
  onConfirm: () => void;
  cancelText: string;
  confirmText: string;
  styles?: any;
}

export const CancelableDialog = ({
  onCancel,
  onConfirm,
  title,
  description,
  confirmText,
  cancelText,
  styles,
}: Props) => {
  const handleConfirm = () => {
    onCancel();
    onConfirm();
  };
  return (
    <Wrapper style={styles}>
      {title && <div className="header">{title}</div>}
      <div className="content">{description}</div>
      <div className="footer">
        <button onClick={onCancel} className="footer__button">
          {cancelText}
        </button>
        <button onClick={handleConfirm} className="footer__button">
          {confirmText}
        </button>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 336px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  @media (max-width: 768px) {
    width: 100%;
  }
  .header {
    font-weight: 700;
    font-size: 24px;
    line-height: 36px;
    color: black;
    @media (max-width: 768px) {
      font-size: 20px;
      line-height: 30px;
    }
  }
  .content {
    word-break: keep-all;
    font-size: 18px;
    line-height: 27px;
    color: #3d3d3d;
    @media (max-width: 768px) {
      font-size: 16px;
      line-height: 24px;
    }
  }
  .footer {
    display: flex;
    justify-content: flex-end;
    gap: 16px;
    & .footer__button {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: auto;
      width: 104px;
      height: 48px;
      border-radius: 4px;
      background-color: #475ac1;
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      color: white;
      &:first-of-type {
        width: 76px;
        background-color: #f6f8ff;
        color: #475ac1;
      }
    }
  }
`;
